import Grid from "@mui/material/Grid";
import { set } from "date-fns";
import { useEffect, useState } from "react";

// @mui material components

// Argon Dashboard 2 PRO MUI components
import { useTranslation } from "react-i18next";

import BookingCalendar from "0.Mine/0.Components/CRM/Customers/BookingCalendar";
import CustomerLineChart from "0.Mine/0.Components/CRM/Customers/CustomerLineChart";
import ReminderSelector from "0.Mine/0.Components/CRM/Customers/LeadReminder";
import CustomerManagementApp from "0.Mine/0.Components/CRM/Customers/TableView";
import CRMFunnelBoard from "0.Mine/0.Components/CRM/Leads/CRMFunnelBoard";
import { UseHandleCustomers } from "0.Mine/1.Hooks/CRM/Customers";
import { mapRawLeadToLead, UseHandleLeads } from "0.Mine/1.Hooks/CRM/Leads";
import { useBusinessContext } from "0.Mine/2.Context/businessContext";
import ArgonBox from "components/ArgonBox";

// Argon Dashboard 2 PRO MUI example components
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import DefaultLineChart from "examples/Charts/LineCharts/DefaultLineChart";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import BusinessNavbar from "examples/Navbars/DashboardNavbar/businessNavbar";
import CRMTable from "examples/Tables/Table/CRMLeadsTable";
import BusinessCalendar from "layouts/ecommerce/products/new-product/BusinessCalendar";

import Table from "../../../../0.Mine/0.Components/CRM/Customers/Table";

// Status change handler

function CRMBookings() {
  return (
    <DashboardLayout>
      <CRMBookingWithContext />
    </DashboardLayout>
  );
}

function CRMBookingWithContext() {
  const { getAllCustomers } = UseHandleCustomers();
  const { session } = useBusinessContext();
  const [customers, setCustomers] = useState([]);
  const [lifetimeRevenue, setLifetimeRevenue] = useState(0);
  const [totalBookings, setTotalBookings] = useState(0);
  const [uniqueCustomers, setUniqueCustomers] = useState(0);

  const { t } = useTranslation();

  const getUniqueCustomers = (customersData) => {
    if (!Array.isArray(customersData)) return 0;
    if (customersData.length === 0) return 0;
    let totalPaid = 0;
    const uniqueClientsId = new Set();
    customersData.forEach((customer) => {
      if (customer.client_id) {
        uniqueClientsId.add(customer.client_id);
      }

      const serviceDetails = customer.serviceDetails;
      if (serviceDetails && serviceDetails.length > 0) {
        serviceDetails.forEach((service) => {
          console.log(service);
          totalPaid += Number.parseInt(service.details.amount_paid);
        });
      }
    });

    return {
      uniqueCount: uniqueClientsId.size,
      totalRevenue: totalPaid,
    };
  };

  useEffect(() => {
    const fetchData = async () => {
      // First check if session exists and has selectedBusiness
      if (session && session.selectedBusiness) {
        try {
          const data = await getAllCustomers(session.selectedBusiness.id);
          setCustomers(data || []);
          setTotalBookings(data.length);
          const { uniqueCount, totalRevenue } = getUniqueCustomers(data);
          setUniqueCustomers(uniqueCount);
          setLifetimeRevenue(totalRevenue);
        } catch (error) {
          console.error("Error fetching customers:", error);
          setCustomers([]);
        }
      } else {
        setCustomers([]);
      }
    };

    fetchData();
  }, [session]);

  const deleteBooking = (booking) => {
    console.log("Delete booking");
    const newCustomers = customers.filter((customer) => customer.id !== booking.id);
    setCustomers(newCustomers);
  };

  return (
    <ArgonBox py={3}>
      <BusinessNavbar />
      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <ComplexStatisticsCard
                    image="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/reports1.jpg"
                    icon="account_circle"
                    count={{ number: totalBookings, label: t("Prenotazioni totali") }}
                    percentage="+55%"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <ComplexStatisticsCard
                    image="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/reports2.jpg"
                    icon="touch_app"
                    count={{ number: uniqueCustomers, label: t("Clienti unici") }}
                    percentage="+124%"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <ComplexStatisticsCard
                    image="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/reports3.jpg"
                    icon="shopping_cart"
                    count={{ number: lifetimeRevenue, label: t("Revenue totali") }}
                    percentage="+55%"
                  />
                </Grid>
                <Grid item xs={12} md={6}></Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} md={6}>
              <CustomerLineChart />
            </Grid>
          </Grid>
        </ArgonBox>
        <ReminderSelector />
        <BookingCalendar />
        <Table bookings={customers} deleteBooking={deleteBooking} />
      </ArgonBox>
      <Footer />
    </ArgonBox>
  );
}

export default CRMBookings;
